export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            关于我们
          </h2>
          <div className="mt-8 space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-900">爱丫爱丫影院</strong> 是一个专注于高清电影在线观看的内容平台，
              致力于为广大电影爱好者提供最新电影、动作电影、喜剧电影、经典电影的全方位观影服务。
              我们相信，每一部好电影都值得被更多人看到。
            </p>
            <p>
              平台每日更新片源，涵盖华语佳片、好莱坞大片、日韩欧美以及独立制作等多种类型。
              无论是追求肾上腺素飙升的动作大片，还是偏爱温情治愈的喜剧故事，
              抑或是想重温影史经典名作，在这里都能找到属于您的光影时刻。
            </p>
            <p>
              我们的技术团队持续优化播放体验，确保每一位用户都能享受到秒开不缓冲、
              1080P 高清画质的流畅观影。同时，移动端全面适配，让您随时随地畅享电影世界。
            </p>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">3K+</div>
              <div className="text-xs text-foreground-500 mt-1">收录影片</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">50w+</div>
              <div className="text-xs text-foreground-500 mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">1080P</div>
              <div className="text-xs text-foreground-500 mt-1">高清画质</div>
            </div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">24/7</div>
              <div className="text-xs text-foreground-500 mt-1">全天候服务</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}